import {loadingHtml} from "../components/loading";

export function init() {
  $('.form-login').on('submit', (e) => {
    $('.login-register-user').append(loadingHtml());
  });
}


